module.exports = __webpack_public_path__ + "static/media/Step1Withdrawal.8aebcbf9.svg";